
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promo/v-a",
      function () {
        return require("private-next-pages/promo/v-a.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promo/v-a"])
      });
    }
  